import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=06df823e&"
import script from "./Album.vue?vue&type=script&lang=ts&"
export * from "./Album.vue?vue&type=script&lang=ts&"
import style0 from "./Album.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports